import TariffPackage from './TariffPackage.vue';
import api from '@checkout/services/api';
import { mapActions, mapGetters } from 'vuex';
import localStorage from '@checkout/services/storage';
import _ from 'lodash';

export default {
    data() {
        return {
            tariffs: [],
            tvs: [],
            chosenTv: {},
            insurance: false,
            insuranceOpen: false,
            limitCheck: false,
            stock: 100,
            bonus: false,
            tvTariffs: false,
            bonusCanal: '',
            rangeInput: 1,
            tv: true,
            prepaid: true,
            addons: [],
            checkbox2: true,
            slider: {
                center: true,
                slideBy: 1,
                mouseDrag: true,
                nav: false,
                navElement: false,
                dotData: true,
                autoWidth: true,
                margin: 30,
                startPosition: 1,
                responsive: {
                    0: {
                        items: 1,
                        center: true,
                    },
                    540: {
                        items: 1,
                        center: true,
                        startPosition: 1,
                    },
                    810: {
                        items: 3,
                        center: false,
                        startPosition: 1,
                    },
                    1080: {
                        items: 4,
                        center: false,
                        startPosition: 0,
                        mouseDrag: false,
                        touchDrag: false,
                    },
                },
            },
        };
    },

    components: {
        TariffPackage
    },

    computed: {
        ...mapGetters(['checkout', 'bonusTv']),

        isTvCheckout() {
            return this.checkout && (this.checkout.type === 'TV Tariff' || this.checkout.type === 'Tv Device');
        },

        isPrepaidTvTariff() {
            return this.checkout.tv_tariff == '277';
        },

        filteredAddons() {
            return this.addons.filter(addon => addon.total);
        },

        checkedLimit: {
            get() {
                if (this.$store.state.checkout.limit) {
                    this.rangeInput = this.$store.state.checkout.limit;
                    this.limitCheck = true;
                    return true;
                }
                return this.$store.state.checkedLimitAgreement;
            },
            set(value) {
                this.$store.commit('SET_CHECKED_LIMIT_AGREEMENT', value);
            },
        },
    },

    watch: {
        rangeInput: function (newVal) {
            this.updateSliderPosition();
            
            this.updateSliderlimit(newVal);
        },

        checkedLimit: function () {
            if (this.checkedLimit) {
                this.updateLimit(this.rangeInput);
            } else {
                this.updateLimit(0);
            }

            this.$root.$emit('reloadCheckout', true);
        },

        limitCheck: function () {
            if (this.limitCheck) {
                this.updateLimit(this.rangeInput);
            } else {
                this.updateLimit(0);
            }

            this.$root.$emit('reloadCheckout', true);
        },

        stock: function () {
            if (this.stock === 0) {
                this.$swal({
                    title: this.$i18nApi.t('noStock'),
                    icon: 'warning',
                    buttons: {
                        confirm: {
                            value: 0,
                        },
                    },
                }).then(() => {
                    if (
                        localStorage.get('locale', true) === 'de'
                    ) {
                        document.location.href = '/';
                    } else {
                        document.location.href =
                            '/' + localStorage.get('locale', true) + '/';
                    }
                });
            }
        },

        bonus: function () {
            if (!this.bonus) {
                this.chosenTv = {};
                this.$store.commit('SET_CHOSEN_TV', {});
                this.$store.commit('SET_CHOSEN_TV_BONUS', 0);
            } else {
                this.$store.commit('SET_CHOSEN_TV_BONUS', 1);
            }
            this.$root.$emit('reloadCheckout', true);
        },
    },

    methods: {
        ...mapActions(['updateLimit', 'updateInsurance']),

        setPickedTv(tv) {
            // If bonus is disabled then dont let user pick chanels
            if (!this.bonus) {
                return;
            }
            this.chosenTv = tv;
            this.$store.commit('SET_CHOSEN_TV', tv);
            this.$store.commit('SET_CHOSEN_TV_BONUS', 1);
            this.$root.$emit('reloadCheckout', true);
        },

        prepareStep1() {
            api.get(
                '/public-api/prepare/1/' + localStorage.get('page-step', true)
            )
                .then((response) => {
                    this.stock = response.data.onStock;
                    this.prepaid = !response.data.postpaid;
                    this.tv = response.data.tv;
                    this.insurance = this.checkout.insurance
                        ? JSON.parse(this.checkout.insurance)
                        : 0;
                    this.getTv();
                    this.getBundles();
                    this.$root.$emit('enableContinueButton');
                })
                .catch((error) => {
                    this.$swal(this.$i18nApi.t('messages.error'));
                    // redirect user to home page if checkout is broken
                    setTimeout(() => {
                        if (
                            this.checkout.hasOwnProperty('tariff') &&
                            this.checkout.tariff === '101080'
                        ) {
                            document.location.href =
                                '/' +
                                localStorage.get('locale', true) +
                                '/';
                        } else {
                            document.location.href =
                                '/' +
                                localStorage.get('locale', true) +
                                '/';
                        }
                    }, 1500);
                });
        },

        getTv() {
            if (!this.checkout.tariff) {
                return;
            }

            api.get(`/public-api/get-mobile-tv/${this.checkout.tariff}`).then(
                (response) => {
                    this.tvs = response.data;

                    if (this.checkout.hasOwnProperty('tv_tariff')) {
                        // this.bonus = true;
                        this.chosenTv = this.tvs.filter(
                            (x) => x.code === this.checkout.tv_tariff
                        )[0];
                    }
                }
            );
        },

        mapInsurance: function () {
            this.insurance = !this.insurance;
            this.updateInsurance(this.insurance ? 1 : 0);
            this.$root.$emit('reloadCheckout', true);
        },

        getBundles() {
            if (!this.checkout.tariff) {
                return;
            }

            api.get(`/public-api/get-bundles/${this.checkout.tariff}/1`)
                .then(response => this.addons = response.data);
        },

        updateSliderPosition() {
            let range = document.querySelector('.slider-wrapper input');
            let hint = document.querySelector('.slider-wrapper .slider-handle');

            let offset = (range.clientWidth - hint.offsetWidth) / (parseInt(range.max) - parseInt(range.min));
            hint.style.left = ((range.valueAsNumber - parseInt(range.min)) * offset) + 'px';
        },

        updateSliderlimit: _.debounce(function (newVal) {
            this.limitCheck = true;
            this.updateLimit(newVal);
            this.$root.$emit('reloadCheckout', true);
        }, 500),
    },

    mounted() {
        this.$root.$once('checkoutReady', () => this.prepareStep1());
    },

    beforeRouteUpdate(to, from, next) {
        this.prepareStep1();
        next();
    },
};
